module.exports = __webpack_public_path__ + "img/img-bg-big.232c0715.png";